import { AllData, UsuarioFornecedorToken, UsuarioToken } from 'hooks/useAuth'
import { createActions, createReducer } from 'reduxsauce'

export interface IAuthenticate {
  data: AllData
  user: UsuarioToken
  csn: UsuarioFornecedorToken
  fornecedor: UsuarioFornecedorToken
  tipo: string
  logged: boolean
  token: string
}
const { Types, Creators } = createActions({
  csn: ['csn'],
  data: ['data'],
  fornecedor: ['fornecedor'],
  logged: ['logged'],
  tipo: ['tipo'],
  token: ['token'],
  user: ['user']
})

export const AuthenticateTypes = Types

export default Creators

const INITIAL_STATE = {
  csn: null,
  data: null,
  fornecedor: null,
  logged: false,
  tipo: null,
  token: null,
  user: null
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TIPO]: (state, { tipo }) => ({ ...state, tipo }),
  [Types.TOKEN]: (state, { token }) => ({ ...state, token }),
  [Types.LOGGED]: (state, { logged }) => ({ ...state, logged }),
  [Types.DATA]: (state, { data }) => ({ ...state, data }),
  [Types.USER]: (state, { user }) => ({ ...state, user }),
  [Types.CSN]: (state, { csn }) => ({ ...state, csn }),
  [Types.FORNECEDOR]: (state, { fornecedor }) => ({
    ...state,
    fornecedor
  })
})
